<div class="page-header">
  <div>
    <h2>Организации</h2>
    <p>Управление организациями и банковскими реквизитами</p>
  </div>
  <div class="header-actions">
    <a routerLink="/org/create" mat-flat-button color="primary">
      <mat-icon>add</mat-icon>
      Создать организацию
    </a>
  </div>
</div>

<div class="layout" [formGroup]="searchForm">
  <div class="content">
    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

    <div *ngIf="!loading && !dataSource.length" class="empty-state">
      <mat-icon>domain_disabled</mat-icon>
      <h3>Организации не найдены</h3>
      <p>Измените фильтры или создайте новую организацию</p>
      <a routerLink="/org/create" mat-flat-button color="primary">
        <mat-icon>add</mat-icon>
        Создать организацию
      </a>
    </div>

    <div *ngIf="loading" class="skeleton-grid">
      <div class="skeleton-card" *ngFor="let item of [1, 2, 3, 4]"></div>
    </div>

    <div *ngIf="!loading && dataSource.length" class="cards-grid">
      <mat-card class="org-card" *ngFor="let org of dataSource">
        <div class="org-card-header">
          <div>
            <h3>{{ org.name }}</h3>
            <p>{{ org.fullName || 'Полное название не указано' }}</p>
          </div>
          <span class="status" [class.active]="org.isActive" [class.inactive]="!org.isActive">
            {{ org.isActive ? 'Активна' : 'Неактивна' }}
          </span>
        </div>

        <div class="org-card-info">
          <div><strong>ЕДРПОУ:</strong> {{ org.edrpou || '—' }}</div>
          <div><strong>ИНН:</strong> {{ org.ipn || '—' }}</div>
          <div><strong>Налогообложение:</strong> {{ org.taxationType || '—' }}</div>
          <div><strong>Телефон:</strong> {{ org.phone || '—' }}</div>
          <div><strong>Email:</strong> {{ org.email || '—' }}</div>
          <div><strong>Юр. адрес:</strong> {{ org.legalAddress || '—' }}</div>
        </div>

        <div class="bank-summary">
          <div class="bank-summary-title">
            Счета: {{ org.bankAccounts?.length || 0 }}
            <span *ngIf="org.bankAccounts?.length">(активных: {{ getActiveAccountsCount(org) }})</span>
          </div>
          <div class="bank-summary-primary" *ngIf="getPrimaryAccount(org) as primary">
            Основной: {{ primary.iban }}
            <span *ngIf="primary.bankName">({{ primary.bankName }})</span>
          </div>
        </div>

        <div class="org-card-actions">
          <a mat-stroked-button routerLink="/org/edit/{{ org.id }}">
            <mat-icon>edit</mat-icon>
            Редактировать
          </a>
          <button mat-stroked-button color="warn" type="button" (click)="delete(org)">
            <mat-icon>delete</mat-icon>
            Удалить
          </button>
        </div>
      </mat-card>
    </div>

    <mat-paginator
      [length]="resultsLength"
      [pageSize]="pageSize"
      (page)="searchByPage($event.pageIndex)"
    ></mat-paginator>
  </div>

  <aside class="filters-sidebar">
    <mat-card>
      <form class="filters-content" [formGroup]="searchForm" (ngSubmit)="search()">
        <h3>Расширенный поиск</h3>

        <mat-form-field appearance="outline">
          <mat-label>Название</mat-label>
          <input
            matInput
            formControlName="name"
            placeholder="Поиск по названию"
            (keydown.enter)="search()"
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>ЕДРПОУ</mat-label>
          <input
            matInput
            formControlName="edrpou"
            placeholder="Поиск по ЕДРПОУ"
            (keydown.enter)="search()"
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>ИНН</mat-label>
          <input matInput formControlName="ipn" (keydown.enter)="search()" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Система налогообложения</mat-label>
          <mat-select formControlName="taxationType">
            <mat-option [value]="null">Все</mat-option>
            <mat-option *ngFor="let type of taxationTypes" [value]="type">{{ type }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Статус</mat-label>
          <mat-select formControlName="isActive">
            <mat-option value="all">Все</mat-option>
            <mat-option value="true">Активные</mat-option>
            <mat-option value="false">Неактивные</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="filters-actions">
          <button mat-flat-button color="primary" type="submit">
            <mat-icon>search</mat-icon>
            Найти
          </button>
          <button mat-stroked-button type="button" (click)="clearSearch()">Очистить</button>
        </div>
      </form>
    </mat-card>
  </aside>
</div>
